//Core
import React, {FC} from 'react';
import {Routes} from "./routes";

//Layout
//Styled
import {BodyContainer} from "./components/styled"
import {Snack} from "../snack";

import {SnackbarProvider} from "notistack";
import {Box, ThemeProvider} from "@mui/material";
import {useMainTranslationHookInit} from "../../../newShared/hooks/useMainTranslationHooks/useInit";
import {
    useWorkspacesAndOrganizations
} from "../../authWorkspacesCookies/workspaces/hooks/useWorkspacesAndOrganizations";
import {FlexStart} from '../../../newShared/components/Layouts';
import {Spinner} from "../../../newShared/components/Spinner";
import {SubscriptionHandler} from "../SubscriptionHandler";
import {useSideBar} from "./hooks/useSideBar";
import {TopBar} from "../topBar";
import {LeftMenu} from "../leftMenu";
import colors from "../../../newShared/theme/colors";
import {MessageDialog} from "../MessageDialog";
import {DocViewerDialog} from "../../../newShared/components/docViewer";


export const Shell: FC = () => {
    const isHiddenBar = useSideBar();
    const {revDir, themeWithLocale} = useMainTranslationHookInit();

    //when workspace or organization is not selected - disabling  buttons and paths user can't go without selection
    const {isLoadingCookieData, isSignedIn} = useWorkspacesAndOrganizations();

    return (
        <ThemeProvider theme={themeWithLocale}>
            <SnackbarProvider anchorOrigin={{ vertical: 'bottom', horizontal: !revDir ? 'right' : 'left' }} preventDuplicate>
                <FlexStart w={"100vw"} h={"100vh"} of={"hidden"} d={'column'}>
                    <TopBar isHidden={isHiddenBar}/>
                    <BodyContainer w={'100%'}>
                        <Snack/>
                        {isSignedIn && <LeftMenu/>}
                        <Box overflow={"hidden"} height={'100%'} width={'100%'} bgcolor={colors.backgrounds.white}>
                            {!isLoadingCookieData ? <Routes/> : <Spinner />}
                            {(isSignedIn) && <SubscriptionHandler />}
                            <MessageDialog/>
                            <DocViewerDialog/>
                        </Box>
                    </BodyContainer>
                </FlexStart>
            </SnackbarProvider>
        </ThemeProvider>
    )
}
